import { useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const AlertNotifications = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://support.atlassian.com${useLocalizedHref(
        "/jira-service-management-cloud/docs/set-up-your-alert-notifications/"
    )}'`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AlertNotifications.header",
            defaultMessage: "Alert notifications per month"
        }),
        body: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AlertNotifications.body",
                defaultMessage:
                    "<p>Route every alert to the correct team or person and help ensure your team doesn’t miss critical alerts. When an incident is raised, people and teams can be added to the incident as responders so they can work to resolve it.</p><p>Link alerts to incidents, or add and alert multiple responders to one incident. When alerts are enabled and a responder is added to an incident, the responder will be alerted according to their alert notification preferences and the priority of the alert.</p><p>The Free plan is limited to 200 SMSs per month account-wide: 100 to the United States and Canada, 100 to other destinations.</p><p>Premium and Enterprise plans include:</p>"
            },
            {
                ...DEFAULT_VALUES
            }
        ),
        listItems: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AlertNotifications.listItems",
                defaultMessage:
                    "<li>Automated Opsgenie actions</li> <li>Advanced alert enrichment</li> <li>Advanced alert customization</li> <li>Custom alert actions</li> <li>Alert and notification policies</li> <li>Multiple notification rules per contact type</li> <li>Attachments and notes in alerts</li>"
            },
            {
                li: (chunk: React.ReactNode) => <li>{chunk}</li>
            }
        ),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AlertNotifications.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about setting up alert notifications."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <>{messages.body}</>
            <ul>{messages.listItems}</ul>
            <p>{messages.link}</p>
        </>
    );
};

export default AlertNotifications;
